import { Text } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfText = ({
  children,
  variant,
  bold,
  fontWeight = "normal",
  fontSize = 10,
  style,
}) => {
  const styles = useMemo(() => {
    let fontSizeValue = fontSize;
    let colorValue = "#000000";
    let fontWeightValue = fontWeight;

    if (variant === "small") {
      fontSizeValue = 8;
      colorValue = "#666666";
    }

    if (bold) {
      fontWeightValue = "bold";
    }

    return {
      fontSize: fontSizeValue,
      fontWeight: fontWeightValue,
      color: colorValue,
      ...style,
    };
  }, [variant, fontSize, style, bold, fontWeight]);

  return <Text style={styles}>{children}</Text>;
};
export default PdfText;
